import { FormControl, FormGroup, ValidatorFn } from '@angular/forms';

import { ObjectLike } from 'app/interfaces';
import { FieldValidatorsMap, FormValidatorsMap } from 'app/services/validators/rules/interfaces';

export abstract class FormModel<T extends number> {
    abstract baseValidators: FieldValidatorsMap;
    abstract formValidators: FormValidatorsMap;

    getValidators(action: T, field: string): ValidatorFn[] {
        return this.getBaseValidators(field).concat(this.getActionValidators(action, field));
    }

    protected createFormGroup(action: T, formFrom: ObjectLike = {}): FormGroup {
        const controls: { [prop: string]: FormControl } = {};

        // First we create form controls for each key
        for (const key in formFrom) {
            if (formFrom.hasOwnProperty(key)) {
                controls[key] = this.createFormControl(action, key, formFrom[key]);
            }
        }

        // Then we add validity checks to validators dependent on separate fields
        // (Hack for validator to update validity on value change)
        for (const key in controls) {
            if (controls.hasOwnProperty(key)) {
                const validators = this.getValidators(action, key);

                validators.forEach((validator: any) => {
                    if (validator.requireFields) {
                        validator.requireFields.forEach((fieldName) => {
                            controls[fieldName].registerOnChange(() => {
                                controls[key].updateValueAndValidity();
                            });
                        });
                    }
                });
            }
        }

        return new FormGroup(controls);
    }

    private createFormControl(action: any, field: string, value: any = null): FormControl {
        const validators: ValidatorFn[] = this.getValidators(action, field);

        return new FormControl(value, validators);
    }

    private getActionValidators(action: any, field: string): ValidatorFn[] {
        if (!this.formValidators.hasOwnProperty(action) || !this.formValidators[action].hasOwnProperty(field)) {
            return [];
        }
        return this.formValidators[action][field];
    }

    private getBaseValidators(field: string): ValidatorFn[] {
        if (!this.baseValidators.hasOwnProperty(field)) {
            return [];
        }
        return this.baseValidators[field];
    }
}
